import { render } from "./ThreeFullorder.vue?vue&type=template&id=fbc8fd6e&scoped=true&ts=true"
import script from "./ThreeFullorder.vue?vue&type=script&lang=ts"
export * from "./ThreeFullorder.vue?vue&type=script&lang=ts"

import "./ThreeFullorder.vue?vue&type=style&index=0&id=fbc8fd6e&lang=scss&scoped=true"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbc8fd6e"]])

export default __exports__